/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/Id/Content"
  
}) {
let constantData = 'id: '
let questionIdValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'id',
})
let aggregateData = fromAggregate.join(constantData, questionIdValueData)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral400}
 fontStyle="italic"
 data="'id: '"
 data="question.id"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}